export const locationScroll = () => {
    document.addEventListener('DOMContentLoaded', () => {
        const currentUrl = new URL(window.location.href);
        const params = new URLSearchParams(currentUrl.search);
        
        // Check if the url contains the initial-region parameter
        if ( params.has('initial-region') ) {
            const region = params.get('initial-region');
            const regionElement = document.querySelector(`[data-region-name="${region}"]`);
    
            // Check if the region elemeent exists
            if ( regionElement ) {
                // Store the header height in a const
                const headerHeight = document.querySelector('header').offsetHeight;
                
                // Set a small timeout before scrolling to the element
                setTimeout(() => {
                    // Scroll to the top of the element minus the height of the header
                    window.scrollTo({
                        top: regionElement.offsetTop - headerHeight
                    });
                }, 200);
            }
        }
    });
};